import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress non-actionable cross-origin errors from the PayPal SDK (dev overlay only).
const isBenign = (msg) =>
  !msg ||
  msg === "Script error." ||
  msg.includes("zoid destroyed") ||
  msg.toLowerCase().includes("paypal");

window.addEventListener("error", (e) => {
  if (isBenign(e.message)) e.stopImmediatePropagation();
}, true);
window.addEventListener("unhandledrejection", (e) => {
  const msg = (e.reason && (e.reason.message || String(e.reason))) || "";
  if (isBenign(msg)) e.stopImmediatePropagation();
}, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
